export const UPDATE_HOLIDAY_SCHEDULE = 'UPDATE_HOLIDAY_SCHEDULE';
export const UPDATE_HOLIDAY_SCHEDULE_SUCCESS = 'UPDATE_HOLIDAY_SCHEDULE_SUCCESS';
export const UPDATE_HOLIDAY_SCHEDULE_FAILURE = 'UPDATE_HOLIDAY_SCHEDULE_FAILURE';

export const updateHolidaySchedule = (payload: any) => ({
  type: UPDATE_HOLIDAY_SCHEDULE,
  payload,
});

export const updateHolidayScheduleSuccess = (payload: any) => ({
  type: UPDATE_HOLIDAY_SCHEDULE_SUCCESS,
  payload,
});

export const updateHolidayScheduleFailure = (payload: any) => ({
  type: UPDATE_HOLIDAY_SCHEDULE_FAILURE,
  payload,
});
